import BloodGlucose from './BloodGlucose';

export default BloodGlucose;
